module.exports = __webpack_public_path__ + "static/img/redCircle.5ed85417.svg";